module.exports = __webpack_public_path__ + "img/ganlanlv.1a09121f.png";